export const ACTION_SUBMIT_PURCHASE_ON_SPOT = '/clientteling/submit-purchase-on-spot';